import * as React from 'react';
import { SectionTwoIsometricContainer, GridWrapper, GridTile, SectionTwoWraper, TextWrapper } from './SectionTwo.s';
import range = require('lodash/range');
import { Heading, Paragraph, ParagraphMinItalic } from '@components/Typos/Typos.s';
import { SectionContent } from '@components/Sections/Sections.s';

import expo01 = require('./expos/01.png');
import expo02 = require('./expos/02.png');
import expo03 = require('./expos/03.png');
import expo04 = require('./expos/04.png');
import expo05 = require('./expos/05.png');
import expo06 = require('./expos/06.png');
import expo07 = require('./expos/07.png');
import expo08 = require('./expos/08.png');
import expo09 = require('./expos/09.png');
import expo10 = require('./expos/10.png');
import expo11 = require('./expos/11.png');
import expo12 = require('./expos/12.png');

const exposImages = [expo01, expo02, expo03, expo04, expo05, expo06, expo07, expo08, expo09, expo10, expo11, expo12];

export const SectionTwo = () => (
  <SectionTwoWraper>
    <SectionContent>
      <TextWrapper>
        <Heading>Un peu trop de choix ? </Heading>
        <Paragraph>
          Tu te sens perdu dans cet océan d’expositions ? Tu ne sais jamais laquelle faire, ou alors tu n’as pas le
          temps de faire des recherches ? <b>Start est fait pour toi !</b>
        </Paragraph>
        <ParagraphMinItalic>
          50% des personnes ne vont pas voir d’expositions parce qu’ils n ‘ont pas le temps de s’informer*
        </ParagraphMinItalic>
      </TextWrapper>
    </SectionContent>
    <SectionTwoIsometricContainer>
      <GridWrapper>
        {range(36).map(index => (
          <GridTile key={index} bg={exposImages[index % exposImages.length]} />
        ))}
      </GridWrapper>
    </SectionTwoIsometricContainer>
  </SectionTwoWraper>
);



// WEBPACK FOOTER //
// src/app/src/components/SectionTwo/SectionTwo.tsx